function installAnalitic(store) {
  const isProd = store.getters["ConfigStore/isProd"];
  const googleAnaliticKey = store.getters["ConfigStore/getGoogleAnaliticId"];
  if (!googleAnaliticKey) {
    console.error(
      `Did not find google analitic id by ConfigStore/getGoogleAnaliticId `
    );
    return;
  }

  const protocol = isProd ? "https" : "http";
  const scripts = [
    {
      src: `${protocol}://www.googletagmanager.com/gtag/js?id=${googleAnaliticKey}`,
    },
    {
      text: `
      window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${googleAnaliticKey}');
        console.log('add ga settings');
      `,
    },
  ];

  scripts.forEach((scriptObj) => {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (scriptObj.src) {
      script.src = scriptObj.src;
    } else {
      script.text = scriptObj.text;
    }
    document.head.appendChild(script);
  });
}

function trackOutboundLink(url) {
  if (!gtag) {
    console.error(`try trackOutboundLink but gtag is undefined`);
    return;
  }
  gtag("event", "click", {
    event_category: "outbound",
    event_label: url,
    event_callback: function () {
      document.location = url;
    },
  });
}
function trackUserAction(store, label) {
  if (!gtag) {
    console.error(`try trackUserAction but gtag is undefined`);
    return;
  }
  const userEmail = store.getters["UserStore/getUserEmail"];
  if (!userEmail) {
    console.error(`try trackUserAction without user email`);
    return;
  }
  gtag("event", userEmail || "", {
    event_category: userEmail,
    event_label: label || "",
  });
}

export default {
  installAnalitic,
  trackOutboundLink,
  trackUserAction,
};
